import classNames from 'classnames';
import React, { useEffect } from 'react';
import { Radio } from 'tdesign-react';

import styles from './index.module.less';

export interface CustomRadioOption {
  value: any;
  label: string;
  desc: string[];
  icon: React.ReactNode;
}

interface IProps {
  onChange: (value: any) => void;
  value: any;
  disabled: boolean;
  options: CustomRadioOption[];
  defaultValue?: any;
}

const CustomDub: React.FC<IProps> = (props) => {
  const {
    onChange,
    value,
    disabled = false,
    options,
    defaultValue,
  } = props;

  useEffect(() => {
    if (value === undefined && defaultValue !== undefined) {
      onChange(defaultValue);
    }
  }, [value, defaultValue]);

  const handleClick = (val: CustomRadioOption['value']) => {
    if (!disabled) {
      onChange(val);
    }
  };

  return (
    <div className={styles.group}>
      {options?.map(opt => (
        <div className={classNames(styles.option, {
          [styles['option-selected']]: value === opt.value,
          [styles['option-disabled']]: disabled,
          [styles['option-enabled']]: !disabled,
        })}
          key={opt.value}
          onClick={() => handleClick(opt.value)}
        >
          <div className={styles.logo}>
            {opt.icon}
          </div>
          <div className={styles.right}>
            <div className={styles.header}>
              <div className={styles.left}>
                {opt.label}
              </div>
              <Radio disabled={disabled} checked={value === opt.value} />
            </div>
            <div className={styles.content}>
              {opt.desc?.map((e, i) => (
                <div key={i}>{e}</div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomDub;
